import { css } from 'styled-components'

export const bannerKindStyles = css`
  --banner-kind-loyalty-gradient-direction: to right;

  [dir="rtl"] & {
    --banner-kind-loyalty-gradient-direction: to left;
  }

  &.kind-default {
    background-color: var(--palette-neutral-surface-normal-background);
    color: var(--palette-neutral-surface-normal-contrast);
  }
  &.kind-informational {
    background-color: var(--palette-neutral-surface-light-background);
    color: var(--palette-neutral-surface-light-contrast);
  }
  &.kind-promotional {
    background-color: var(--palette-highlight-primary-normal-background);
    color: var(--palette-highlight-primary-normal-contrast);
  }
  &.kind-branded {
    background-color: var(--palette-highlight-primary-dark-background);
    color: var(--palette-highlight-primary-dark-contrast);
  }
  &.kind-urgency {
    background-color: var(--palette-messaging-urgency-normal-background);
    color: var(--palette-messaging-urgency-normal-contrast);
  }
  &.kind-success {
    background-color: var(--palette-messaging-success-light-background);
    color: var(--palette-messaging-success-light-contrast);
  }
  &.kind-warning {
    background-color: var(--palette-messaging-warning-light-background);
    color: var(--palette-messaging-warning-light-contrast);
  }
  &.kind-critical {
    background-color: var(--palette-messaging-critical-light-background);
    color: var(--palette-messaging-critical-light-contrast);
  }
  &.kind-lux-plus {
    background-color: var(--palette-product-lux-plus-background);
    color: var(--palette-product-lux-plus-contrast);
  }
  &.kind-loyalty-bronze {
    background: linear-gradient(var(--banner-kind-loyalty-gradient-direction), var(--palette-product-loyalty-bronze-normal-background), var(--palette-product-loyalty-bronze-light-background));
    color: var(--palette-product-loyalty-bronze-normal-contrast);
  }
  &.kind-loyalty-silver {
    background: linear-gradient(var(--banner-kind-loyalty-gradient-direction), var(--palette-product-loyalty-silver-normal-background), var(--palette-product-loyalty-silver-light-background));
    color: var(--palette-product-loyalty-silver-normal-contrast);
  }
  &.kind-loyalty-gold {
    background: linear-gradient(var(--banner-kind-loyalty-gradient-direction), var(--palette-product-loyalty-gold-normal-background), var(--palette-product-loyalty-gold-light-background));
    color: var(--palette-product-loyalty-gold-normal-contrast);
  }
  &.kind-loyalty-platinum {
    background: linear-gradient(var(--banner-kind-loyalty-gradient-direction), var(--palette-product-loyalty-platinum-normal-background), var(--palette-product-loyalty-platinum-light-background));
    color: var(--palette-product-loyalty-platinum-normal-contrast);
  }
  &.kind-loyalty-infinite {
    background: linear-gradient(var(--banner-kind-loyalty-gradient-direction), var(--palette-product-loyalty-infinite-normal-background), var(--palette-product-loyalty-infinite-light-background));
    color: var(--palette-product-loyalty-infinite-normal-contrast);
  }
`
